module.exports = __webpack_public_path__ + "static/media/8.20e54120.JPG";